/**
 * As-of scrubber. Plumbed for synthetic ticks at v0.83.0
 * (real chain history wires in when BLAST_RADIUS deriver lands).
 *
 * The page shell owns the asOf state + tick selection; this
 * component is a controlled visual.
 */
import { useTranslation } from "react-i18next";

export interface ScrubberTick {
  label: string;
  /** "now" = no as_of param; otherwise an ISO datetime. */
  asOf: string | null;
}

export interface CapMapScrubberProps {
  ticks: ScrubberTick[];
  selectedIndex: number;
  playing: boolean;
  onSelect: (index: number) => void;
  onTogglePlay: () => void;
}

export function CapMapScrubber({
  ticks,
  selectedIndex,
  playing,
  onSelect,
  onTogglePlay,
}: CapMapScrubberProps): JSX.Element {
  const { t } = useTranslation();
  const cur = ticks[selectedIndex];
  return (
    <div data-testid="capmap-scrubber" className="capmap-scrubber">
      <button
        type="button"
        data-testid="capmap-scrubber-play"
        onClick={onTogglePlay}
        className="capmap-scrubber-play"
      >
        {playing ? "❚❚" : "▶"}
      </button>
      <div className="capmap-scrubber-clock" data-testid="capmap-scrubber-clock">
        {/* Round 14 B5 -- a step of a demonstration, said so beside it,
            so "channels degraded" cannot be read as this estate. */}
        <span data-testid="capmap-scrubber-demo" className="me-1 opacity-70">
          {t("modules.twin.capmap.scrubber.demonstration")}
        </span>
        <b>{cur?.label ?? "—"}</b>
      </div>
      <ol data-testid="capmap-scrubber-ticks" className="capmap-scrubber-ticks">
        {ticks.map((tick, i) => (
          <li key={i}>
            <button
              type="button"
              data-testid="capmap-scrubber-tick"
              data-index={i}
              data-active={i === selectedIndex ? "true" : "false"}
              className={
                "capmap-scrubber-tick" +
                (i === selectedIndex ? " capmap-scrubber-tick-cur" : "") +
                (i < selectedIndex ? " capmap-scrubber-tick-passed" : "")
              }
              onClick={() => onSelect(i)}
              // Round 14 B5 -- these steps are not sealed readings.
              title={`${tick.label} · ${t("modules.twin.capmap.scrubber.demonstration")}`}
            />
          </li>
        ))}
      </ol>
    </div>
  );
}
